import type { SVGAttributes } from 'react';

export function DescriptionIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M26.665 11v13c0 4-2.386 5.334-5.333 5.334H10.665C7.72 29.334 5.332 28 5.332 24V11c0-4.333 2.387-5.333 5.333-5.333 0 .827.334 1.573.88 2.12.547.547 1.294.88 2.12.88h4.667c1.653 0 3-1.347 3-3 2.947 0 5.333 1 5.333 5.333"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M21.335 5.667c0 1.653-1.347 3-3 3h-4.667a2.98 2.98 0 0 1-2.12-.88 2.98 2.98 0 0 1-.88-2.12c0-1.653 1.347-3 3-3h4.667c.826 0 1.573.333 2.12.88.546.547.88 1.293.88 2.12"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M10.668 17.333h5.333m-5.333 5.334h10.667"
				opacity=".4"
			/>
		</svg>
	);
}
